/**
 * Maps Profit & Loss Ratios table rows (API `name` keys) onto the shared
 * sector-aware benchmark system.
 */

export const PROFIT_LOSS_RATIOS_PANEL_UNMAPPED = {
    kind: 'notScored',
    reason: 'Unmapped Profit & Loss Ratios row; not scored until a normalized P&L metric is defined.',
};

/** @type {Record<string, { kind: 'scored', metricId: string } | { kind: 'notScored', reason: string }>} */
export const PROFIT_LOSS_RATIOS_PANEL_MAP = {
    grossProfitMargin: { kind: 'scored', metricId: 'grossProfitMargin' },
    ebitdaMargin: { kind: 'scored', metricId: 'ebitdaMargin' },
    operatingProfitMargin: { kind: 'scored', metricId: 'operatingProfitMarginPct' },
    netProfitMargin: { kind: 'scored', metricId: 'netProfitMargin' },
    returnOnEquity: { kind: 'scored', metricId: 'returnOnEquity' },
    returnOnCapitalEmployed: { kind: 'scored', metricId: 'returnOnCapitalEmployed' },
    returnOnAssets: { kind: 'scored', metricId: 'returnOnAssets' },
    roicWaccSpread: { kind: 'scored', metricId: 'roicWaccSpread' },
    interestCoverageEbit: { kind: 'scored', metricId: 'interestCoverageEbit' },
    interestCoverageEbitda: { kind: 'scored', metricId: 'interestCoverageEbitda' },
    dividendPayoutRatio: { kind: 'scored', metricId: 'dividendPayoutRatioScored' },
    earningsPerShare: {
        kind: 'notScored',
        reason: 'Absolute per-share currency value; scales with share count and is not comparable across sectors.',
    },
    operatingRoic: {
        kind: 'notScored',
        reason: 'Input to ROIC minus WACC; not scored in isolation.',
    },
    wacc: {
        kind: 'notScored',
        reason: 'Cost-of-capital input to ROIC minus WACC; not scored as a performance verdict.',
    },
    standardRoic: {
        kind: 'notScored',
        reason: 'Displayed for context; the scored capital-efficiency signal is ROIC minus WACC.',
    },
};

export function getProfitLossRatiosPanelMapping(ratioName) {
    if (!ratioName) return PROFIT_LOSS_RATIOS_PANEL_UNMAPPED;
    return PROFIT_LOSS_RATIOS_PANEL_MAP[ratioName] || PROFIT_LOSS_RATIOS_PANEL_UNMAPPED;
}

export const PROFIT_LOSS_RATIOS_PANEL_SCORED_STATUS = new Set(['strong', 'watch', 'weak']);
